module.exports = __webpack_public_path__ + "img/Screenshot_2021-10-28-16-04-41-629_com.pinkcoffee.sexbattle.18e63023.jpg";